module.exports = __webpack_public_path__ + "img/arrow.ec6df1fc.png";